import { useEffect, useState } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions,
  TextField, } from "@mui/material";
import { useScriptMode } from "../../../contexts/ScriptModeContext";
import { SoftButton, useDialogPaperSx } from "../../hatim/soft/SoftKit";

export default function DeleteHatimTemplateConfirm({ open, name, onClose, onConfirm, loading }) {
  const { t } = useScriptMode();
  const paperSx = useDialogPaperSx();
  const [typed, setTyped] = useState("");

  useEffect(() => {
    if (!open) setTyped("");
  }, [open]);

  const matches = !!name && typed === name;

  return (
    <Dialog open={!!open} onClose={onClose} fullWidth maxWidth="xs" PaperProps={{ sx: paperSx }}>
      <DialogTitle>{t("hatim_mgmt_delete_modal_title")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t("hatim_mgmt_delete_modal_body")}</DialogContentText>
        <TextField
          fullWidth
          label={t("hatim_mgmt_delete_input_label")}
          value={typed}
          onChange={(e) => setTyped(e.target.value)}
          margin="normal"
          autoFocus
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <SoftButton tone="cancel" onClick={onClose} disabled={loading}>
          {t("hatim_mgmt_delete_cancel")}
        </SoftButton>
        <SoftButton tone="danger" disabled={!matches || loading} onClick={onConfirm}>
          {t("hatim_mgmt_delete_confirm")}
        </SoftButton>
      </DialogActions>
    </Dialog>
  );
}
